import {useMutation, useQueryClient} from '@tanstack/react-query';

import {
  addOnboardingExtDataConfig,
  removeOnboardingExtDataConfig,
  updateOnboardingExtDataConfig,
} from '../api';
import {QUERY__ONBOARDING, QUERY__ONBOARDINGS} from '../queryKeys';
import {OnboardingType} from '../types';

const useInvalidateOnboarding = () => {
  const queryClient = useQueryClient();

  return (_: unknown, {type}: {type: OnboardingType}) => {
    void queryClient.invalidateQueries({queryKey: [QUERY__ONBOARDINGS]});
    void queryClient.invalidateQueries({queryKey: [QUERY__ONBOARDING, type]});
  };
};

export const useAddOnboardingExtDataConfig = () => {
  const onSuccess = useInvalidateOnboarding();

  return useMutation({mutationFn: addOnboardingExtDataConfig, onSuccess});
};

export const useUpdateOnboardingExtDataConfig = () => {
  const onSuccess = useInvalidateOnboarding();

  return useMutation({mutationFn: updateOnboardingExtDataConfig, onSuccess});
};

export const useRemoveOnboardingExtDataConfig = () => {
  const onSuccess = useInvalidateOnboarding();

  return useMutation({mutationFn: removeOnboardingExtDataConfig, onSuccess});
};
